<template>
	<v-menu offset-y left :close-on-content-click="false" class="list-cards">
		<template v-slot:activator="{on}">
			<v-icon outlined color="primary" v-on="on">mdi-bug</v-icon>
		</template>

		<v-list class="pb-0">
			<v-list-item class="p-0" style="padding: 0px !important">
				<template>
					<v-list-item-content style="max-width: 250px">
						<v-list-item-title class="headline px-3" style="font-size: 13px !important">
							Dejanos tu comentario u opinión
						</v-list-item-title>
						<!-- <v-list-item-subtitle class="px-3">sub titulo</v-list-item-subtitle> -->

						<div class="border-bottom-states my-2"></div>

						<v-select
							:items="types"
							v-model="type_input"
							ref="types"
							label="Típo"
							outlined
							dense
							class="px-3"
						></v-select>

						<!-- <v-text-field
							v-model="message_input"
							ref="message"
							label="Mensaje"
							outlined
							dense
							class="px-3"
						></v-text-field> -->

						<v-textarea
            v-model="message_input"
							outlined
              dense
							ref="message"
							label="Mensaje"
              class="px-3"
              rows="3"
						></v-textarea>

						<div style="width: 100%" class="px-3">
							<v-btn
								elevation="2"
								color="primary"
								style="float: right; position: relative; top: -5px"
								@click="sendMessage()"
								>Enviar</v-btn
							>
						</div>
					</v-list-item-content>
				</template>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
	import {API_URLS_BOARD} from "@/constants";
	import {mapActions} from "vuex";
	import axios from "axios";

	export default {
		data: () => ({
			type_input: "",
			message_input: "",
			types: ["funcionalidad", "bug", "error"]
		}),
		methods: {
			...mapActions("app", ["showSuccess", "showError", "showToast"]),
			// SEND MESSAGE / BUG REPORT
			sendMessage() {
				this.$Progress.start();

				let url = API_URLS_BOARD.baseUrl + API_URLS_BOARD.bugReportMessageUrl;

				const params = {
					tipo: this.type_input,
					comentario: this.message_input
				};

				return axios
					.post(url, params)
					.then(response => {
						this.type_input = "";
						this.message_input = "";
						this.showSuccess(response.data.message);
						this.$Progress.finish();
					})
					.catch(error => {
						this.$Progress.fail();
						console.log(error.response);
					});
			}
		}
	};
</script>
